import React, { useEffect } from "react";
import DragDropTaskManager from "./dragDropTaskManager";
import { useDispatch } from "react-redux";
import { postData } from "../../../../../actions/developer";
import FormSetup from "../../../../../components/Forms/FormSetup";
import { MasterConfigs } from "../../../../../interfaces/entity";
import { getData } from "../../../../../actions/apiCall";
import { Button } from "antd";

interface TaskProps {
    projectId: string;
    isVisible: boolean;
    onClickIssue: (e: any) => void;
    onClose: () => void;
    showOldSprint?: boolean;
    onSearch: string[];
}

const Baklog: React.FC<TaskProps> = ({
    projectId,
    onClickIssue,
    isVisible,
    onClose,
    onSearch,
    showOldSprint = false
}) => {
    const [isOpen, setOpen] = React.useState(false);
    const [loadData, setLoadData] = React.useState(false);

    useEffect(() => {
        setOpen(isVisible);
    }, [isVisible]);

    const config: MasterConfigs = {
        api: () => `/sprints/${projectId}`,
        apiParams: { projectId },
        modalTitle: () => 'Add Sprint',
        getFormColumns: () => [
            {
                type: 'text',
                name: 'name',
                label: 'Sprint Name',
                rules: [{ required: true, message: 'Please enter sprint name' }]
            },
            {
                span: 16
            },
            {
                type: 'date',
                name: 'startDate',
                label: 'Start Date',
                rules: [{ required: true, message: 'Please enter start date' }]
            },
            {
                type: 'date',
                name: 'endDate',
                label: 'End Date',
                rules: [{ required: true, message: 'Please enter end date' }]
            }
        ],
        onRefresh: () => {
            setLoadData(true)
        }
    }

    return <>
        {!showOldSprint && <FormSetup config={config} isModal={true} open={isOpen} onClose={onClose} />}
        <DragDropTaskManager projectId={projectId}
            onClickIssue={(e) => onClickIssue(e)}
            loadData={loadData}
            onLoaded={() => setLoadData(false)}
            config={config}
            showOldSprint={showOldSprint}
            onSearch={onSearch} />;
    </>
};

export default Baklog;
